import React, { useEffect } from 'react';

const panelStyle = {
  width: 280,
  background: '#16213e',
  borderLeft: '1px solid #333',
  padding: 16,
  overflowY: 'auto',
  color: '#eee',
  fontFamily: 'sans-serif',
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 10,
  marginTop: 12,
};

const cardStyle = {
  background: '#1a1a2e',
  borderRadius: 6,
  padding: 8,
  cursor: 'pointer',
  border: '2px solid transparent',
  textAlign: 'center',
  transition: 'border-color 0.15s',
};

const cardHoverStyle = {
  ...cardStyle,
  border: '2px solid #0f3460',
};

const thumbStyle = {
  width: '100%',
  borderRadius: 4,
  marginBottom: 6,
};

const labelStyle = {
  fontSize: 12,
  fontWeight: 'bold',
  color: '#fff',
  marginBottom: 2,
};

const descStyle = {
  fontSize: 10,
  color: '#999',
};

/**
 * VariantPicker displays skin enhancement variant thumbnails in a selectable grid.
 *
 * @param {{ editor: object }} props
 */
export default function VariantPicker({ editor }) {
  const { variants, skinEnhanceVariants, loading, loadImage } = editor;

  useEffect(() => {
    if (variants.length === 0) {
      skinEnhanceVariants();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelect = (variant) => {
    if (variant.image_data) {
      // image_data is base64 — convert to a data URL and load it
      const src = variant.image_data.startsWith('data:')
        ? variant.image_data
        : `data:image/png;base64,${variant.image_data}`;
      loadImage(src);
    }
  };

  return (
    <div style={panelStyle}>
      <h3 style={{ margin: '0 0 8px', fontSize: 14 }}>Enhancement Variants</h3>
      <p style={{ fontSize: 11, color: '#888', margin: '0 0 8px' }}>
        Select a variant to apply it.
      </p>

      {loading && (
        <p style={{ fontSize: 12, color: '#888' }}>Generating variants…</p>
      )}

      {!loading && variants.length === 0 && (
        <p style={{ fontSize: 12, color: '#888' }}>No variants available.</p>
      )}

      <div style={gridStyle}>
        {variants.map((variant, idx) => (
          <div
            key={idx}
            style={cardStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = '#0f3460';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'transparent';
            }}
            onClick={() => handleSelect(variant)}
          >
            {variant.image_data && (
              <img
                src={
                  variant.image_data.startsWith('data:')
                    ? variant.image_data
                    : `data:image/png;base64,${variant.image_data}`
                }
                alt={variant.label}
                style={thumbStyle}
              />
            )}
            <div style={labelStyle}>{variant.label}</div>
            <div style={descStyle}>{variant.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
